const getVendorTypes = () => {
  const vendorTypes = localStorage.getItem("vendorTypes")
    ? JSON.parse(localStorage.getItem("vendorTypes"))
    : null;

  if (vendorTypes) return vendorTypes;

  return null;
};

const InitialState = {
  vendorTypes: getVendorTypes(),
};

const VendorTypesReducer = (state = InitialState, action) => {
  if (action.type === "Save_VendorTypes") {
    const newState = {
      vendorTypes: action.payload,
    };

    localStorage.setItem("vendorTypes", JSON.stringify(action.payload));

    return newState;
  }

    //logout
  else if (action.type === "Remove_User") {
    const newState = {
      vendorTypes: null,
    };

    localStorage.removeItem("vendorTypes");
    return newState;
  }

  return state;
};

export default VendorTypesReducer;
